import React from 'react';

const CheckboxGroup = ({
  options,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo ${className ? className : ''}`}>
      <div className="rotulo">
        <label htmlFor="numero">{label}</label>
      </div>
      <div className="controle">
        <div className="checkbox-container">
          {options.map((item) => (
            <React.Fragment key={item.id}>
              <label htmlFor={item.id} className='input-checkbox'>
                <input
                  id={item.id}
                  name={name}
                  type="checkbox"
                  defaultChecked={item.checked}
                  value={item.value}
                  ref={inputRef}
                  {...rest}
                  className={`status ${msgErro} ? 'invalid' : ''`}
                />

                {item.label}
              </label>
            </React.Fragment>
          ))}
        </div>
        <div className="mensagem">{msgErro}</div>
      </div>
    </div>
  );
};

export default CheckboxGroup;
